__turbopack_context__.v({
  "active": "layout-module__CUj6aG__active",
  "container": "layout-module__CUj6aG__container",
  "footer": "layout-module__CUj6aG__footer",
  "header": "layout-module__CUj6aG__header",
  "logo": "layout-module__CUj6aG__logo",
  "main": "layout-module__CUj6aG__main",
  "nav": "layout-module__CUj6aG__nav",
  "navLink": "layout-module__CUj6aG__navLink",
  "pageDescription": "layout-module__CUj6aG__pageDescription",
  "pageTitle": "layout-module__CUj6aG__pageTitle",
});
